import { render, staticRenderFns } from "./ServiceProcurementSection.vue?vue&type=template&id=1c9730c8&scoped=true"
import script from "./ServiceProcurementSection.vue?vue&type=script&lang=js"
export * from "./ServiceProcurementSection.vue?vue&type=script&lang=js"
import style0 from "./ServiceProcurementSection.vue?vue&type=style&index=0&id=1c9730c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9730c8",
  null
  
)

export default component.exports